import { useFacets, useProductFilters } from "@nosto/search-js/preact/hooks";
import { SearchStatsFacet, SearchTermsFacet } from "@nosto/nosto-js/client";
import TermsDropdown from "./TermsDropdown/TermsDropdown";
import RangeDropdown from "./RangeDropdown/RangeDropdown";
import ClearFiltersButton from "./ClearFiltersButton/ClearFiltersButton";
import SelectedFilters from "../SelectedFilters/SelectedFilters";

export default function FilterTopbar() {
  const { facets } = useFacets();
  const { filters } = useProductFilters();

  if (!facets || facets.length === 0) {
    return null;
  }

  return (
    <>
      <div className="filter-facets__nav">
        {facets.map((facet) => {
          switch (facet.type) {
            case "terms":
              if (facet.data.length === 0) return <></>;
              return (
                <TermsDropdown
                  key={facet.id}
                  facet={facet as SearchTermsFacet}
                />
              );
            case "stats":
              return (
                <RangeDropdown
                  key={facet.id}
                  facet={facet as SearchStatsFacet}
                />
              );
            default:
              return null;
          }
        })}
      </div>
      {filters.length > 0 && (
        <div className="filter-facets__currently-selected">
          <SelectedFilters />
          <ClearFiltersButton />
        </div>
      )}
    </>
  );
}
